<template>
	<section v-if="data.articles && articleCount>0" :class="['block-wrapper', componentClass, colorMode, { visible: visible, ready: ready }]">
		<div class="row">
			<div class="columns small-12 large-10 large-offset-1 xlarge-8 xlarge-offset-2">
				<h1 class="articles-list-title" v-html="sectionTitle"></h1>
				<article-summary v-for="(article, index) in data.articles" v-bind:key="'article-' + index" v-bind:data="article"></article-summary>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
	@import "../../styles/scss/component/articles-list";
</style>

<script>
import BaseBlock from './Base'
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'articles-list',
		}
	},
	computed: {
		articleCount() {
			return Object.keys(this.data.articles).length
		},
		sectionTitle() {
			return ((typeof this.data.title !== 'undefined') ? this.data.title : this.$t('articles'))
		}
	},
	components: {
		ArticleSummary: () => import('./article/Summary')
	}
}
</script>